export default __webpack_public_path__ + "static/media/F.3cf62cd6.mp3";